export const colors = {
  default: "#000000",
  primary: "#000000",
  lightGrey: "#F2F4FC",
  grey1: "#f8f9fc",
  grey2: "#e1e4e8",
  grey3: "#8e949e",
  grey4: "#3e4b60",
  grey5: "#1d293d",
  background: "#F5F5F5",
};
